import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

const initialState = {
    menus: [],
    error: '',
    message: '',
    loading: null,
    flag: false,
}

export const checkUser = createAsyncThunk(
    'check/user',
    async(token, thunKAPI) => {

        try{
            const response = await axios.post({
                method: 'POST',
                url: `${host}check/user`, 
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                data: {}
            });
            
            return await response.json();

        } catch (error) {
            return thunKAPI.rejectWithValue(error);
        }
    }
)

export const fetchMenus = createAsyncThunk(
    'fetch/menus',
    async(token, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}menus`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                data: {}
            })
            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const navbarSlice = createSlice({
    name: 'navbar',
    initialState,
    reducers: {

    },
    extraReducers: {
        [checkUser.fulfilled] : (state,{ payload }) => {
            
        },
        [fetchMenus.fulfilled]: (state, action) => {
            // console.log(action.payload.data.data)
            // const dd = action.payload.data.data
            // console.log(dd.length)
            // dd.map((value) => {
            //     console.log(value.title)
            // })
            // if(action.payload.data.data && action.payload.status == true){
                state.menus = action.payload.data.data
                // localStorage.setItem('menuss',JSON.parse(action.payload.data.data))
                state.redirectFlag = true
                state.loading = false
            // }
        },
        [fetchMenus.pending]: (state, { payload }) => {
            state.loading = true
            state.message = payload
            state.error = 'error'
        },
        [fetchMenus.rejected]: (state, { payload }) => {
            state.loading = false
            
            if(payload){
                state.error = payload
            }else if(payload) {
                state.message = payload
            }
        }
    }
});

export const {} = navbarSlice.actions;
export default navbarSlice.reducer;